// Configuration for EmailJS service
export const EMAILJS_CONFIG = {
  // Using environment variables for EmailJS credentials
  SERVICE_ID: import.meta.env.VITE_EMAILJS_SERVICE_ID,
  TEMPLATE_ID: import.meta.env.VITE_EMAILJS_TEMPLATE_ID,
  PUBLIC_KEY: import.meta.env.VITE_EMAILJS_PUBLIC_KEY,
  // Admin email where notifications will be sent
  ADMIN_EMAIL: import.meta.env.VITE_ADMIN_EMAIL || "blackrc3636@gmail.com"
}; 